import React from "react";

import {
  ACCOUNT_CATEGORY_LABELS,
  ACCOUNT_TYPE_LABELS,
  Account,
  AccountCategory,
  AccountType,
} from "../../../api/accounts";
import { cn } from "../../../lib/utils";

export interface AccountPopoverRowProps {
  account: Account;
  showDivider?: boolean;
}

const AccountPopoverRow: React.FC<AccountPopoverRowProps> = ({
  account,
  showDivider,
}) => {
  const accountLabel = `${account.account_name || "-"} (${account.ext_account_number})`;
  const typeLabel = account.account_type
    ? ACCOUNT_TYPE_LABELS[account.account_type as AccountType] ?? account.account_type
    : "-";
  const categoryLabel = account.account_category
    ? ACCOUNT_CATEGORY_LABELS[account.account_category as AccountCategory] ??
      account.account_category
    : "-";
  const detailLabel = `${typeLabel} • ${categoryLabel}`;

  return (
    <div
      className={cn(
        "flex flex-col gap-1 px-2 py-[6px]",
        showDivider && "border-t border-[#E5E5E5]",
      )}
    >
      <span className="truncate text-sm text-[#0A0A0A]" title={accountLabel}>
        {accountLabel}
      </span>
      <span className="truncate text-xs text-[#737373]" title={detailLabel}>
        {detailLabel}
      </span>
    </div>
  );
};

export default AccountPopoverRow;
